import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/auth-context'
import { DemoModeProvider } from './contexts/demo-mode-context'
import { AuthGuard } from './components/auth/auth-guard'
import { AdminGuard } from './components/auth/admin-guard'
import { CompanyGuard } from './components/auth/company-guard'
import MainLayout from './layouts/MainLayout'
import { AuthPage } from './pages/auth-page'
import { ForgotPasswordPage } from './pages/forgot-password-page'
import { ResetPasswordPage } from './pages/reset-password-page'
import { HomePage } from './pages/home-page'
import { SensorsOverview } from './pages/sensors-overview'
import { DashboardPage } from './pages/dashboard-page'
import { HistoricalPage } from './pages/historical-page'
import { DeveloperPage } from './pages/developer-page'
import { AdminPortal } from './pages/admin-portal'
import { IssuesPage } from './pages/issues-page'
import { AdminIssuesPage } from './pages/admin-issues-page'
import { NoCompanyAssigned } from './pages/no-company-assigned'

function App() {
	return (
		<AuthProvider>
			<DemoModeProvider>
			<Router>
				<Routes>
					<Route element={<MainLayout />}>
						<Route path="/auth" element={<AuthPage />} />
						<Route path="/login" element={<Navigate to="/auth" replace />} />
						<Route path="/signup" element={<Navigate to="/auth" replace />} />
						<Route path="/forgot-password" element={<ForgotPasswordPage />} />
						<Route path="/reset-password" element={<ResetPasswordPage />} />
						<Route path="/" element={
							<AuthGuard>
								<HomePage />
							</AuthGuard>
						} />
						
						{/* Customer Portal Routes */}
						<Route path="/sensors" element={
							<CompanyGuard>
								<SensorsOverview />
							</CompanyGuard>
						} />
						<Route path="/dashboard" element={
							<CompanyGuard>
								<DashboardPage />
							</CompanyGuard>
						} />
						<Route path="/historical" element={
							<CompanyGuard>
								<HistoricalPage />
							</CompanyGuard>
						} />
						<Route path="/developer" element={
							<CompanyGuard>
								<DeveloperPage />
							</CompanyGuard>
						} />
						<Route path="/issues" element={
							<CompanyGuard>
								<IssuesPage />
							</CompanyGuard>
						} />
						{/*<Route path="/sandbox" element={
							<CompanyGuard>
								<SandboxPage />
							</CompanyGuard>
						} />*/}
						
						{/* Admin Portal */}
						<Route path="/admin-portal" element={
							<AdminGuard>
								<AdminPortal />
							</AdminGuard>
						} />
						<Route path="/admin-portal/issues" element={
							<AdminGuard>
								<AdminIssuesPage />
							</AdminGuard>
						} />
						
						<Route path="/no-company" element={
							<AuthGuard>
								<NoCompanyAssigned />
							</AuthGuard>
						} />
						<Route path="*" element={<Navigate to="/" replace />} />
					</Route>
				</Routes>
			</Router>
			</DemoModeProvider>
		</AuthProvider>
	)
}

export default App
